exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[name='search'] {\n  background-image: url('/themes/oc-jigsaw-blog-theme/assets/images/magnifying-glass.svg');\n  background-position: 0.8em;\n  background-repeat: no-repeat;\n  border-radius: 25px;\n  text-indent: 1.2em;\n}\ninput[name='search'].transition-border {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: .5rem;\n  border-top-right-radius: .5rem;\n}\n.fade-enter-active {\n  transition: opacity .5s;\n}\n.fade-leave-active {\n  transition: opacity 0s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports
